import { Link } from '@remix-run/react';
import LogoImg from '#app/assets/favicons/apple-touch-icon.png';

export default function Logo() {
	return (
		<Link className="inline-flex" to="/" aria-label="Cruip">
			<img
				className="max-w-none"
				src={LogoImg}
				width={38}
				height={38}
				alt="Stellar"
			/>
		</Link>
	);
}
